<style lang="scss">
.login-modal {
  overflow-y: auto;
  .login-wrapper,
  .register-wrapper {
    //transition: max-height 0.4s;
    overflow: hidden;
    max-height: 0px;
  }
  .login-wrapper.show {
    max-height: 800px;
  }
  .register-wrapper.show {
    max-height: 800px;
  }
  .remember-me {
    margin-top: 0;
  }
  .login-button {
    margin-top: 20px;
  }
  .button-label {
    //padding-top: 30px;
    text-align: center;
  }
  .form-control-feedback {
    right: 10px;
  }
  .register-tab {
    font-size: 20px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
    margin: 20px;
    cursor: pointer;
  }

  .login-tab {
    font-size: 20px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
    margin: 20px;
    cursor: pointer;
  }

  .selected-tab {
    color: #ff5b94;
    border-bottom: 1px solid;
  }

  .form-control {
    border-radius: 5px !important;
    font-family: Poppins !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }

  .md-check > i:before {
    width: 16px !important;
    height: 16px !important;
    border-radius: 3px !important;
    border: 1px solid #a7a7a7 !important;
  }

  .md-check > i:after {
    left: 6px !important;
    top: 1px !important;
    width: 5px !important;
    height: 12px !important;
  }

  .control-label {
    color: #595e63;
    font-size: 14px;
  }

  .tabs-menu {
    margin-bottom: 30px;
  }

  .btn-login {
    background-color: #00d38a;

    &:hover {
      color: #fff;
    }
  }
  .btn-login-secondary {
    background-color: purple;

    &:hover {
      color: #fff;
    }
  }

  .url-link {
    color: #ff5b94;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
  }

  .terms-link {
    padding-top: 0px;
    margin-top: 0px;
    margin-bottom: 20px;
    font-size: 14px;
    text-align: left;
  }

  .modal-title {
    text-align: center;
    margin-top:20px;
  }
}
.text-danger {
  span {
    color: #f70075;
    font-weight: 600;
    margin-top: 3px;
    font-size: 0.8em;
  }
}
.text-center{
  margin-top:1rem;
}
.pull-right{
  padding-top:6px;
}
input[type=checkbox] + label {
  display: block;
  margin: 0.2em;
  cursor: pointer;
  padding: 0.2em;
}

input[type=checkbox] {
  display: none;
}

input[type=checkbox] + label:before {
  content: "\2714";
  border: 0.1em solid var(--secondary-border-color);
  border-radius: 0.2em;
  display: inline-block;
  width: 1.6em;
  height: 1.6em;
  padding-left: 0.3em;
  margin-right: 0.4em;
  vertical-align: middle;
  color: transparent;
  transition: .2s;
}

input[type=checkbox] + label:active:before {
  transform: scale(0);
}

input[type=checkbox]:checked + label:before {
  background-color: var(--main-background-color);
  border-color: var(--main-background-color);
  color: var(--main-color);
}

input[type=checkbox]:disabled + label:before {
  transform: scale(1);
  border-color: #aaa;
}

input[type=checkbox]:checked:disabled + label:before {
  transform: scale(1);
  background-color: #bfb;
  border-color: #bfb;
}
input[type=checkbox]:checked:disabled + label {
  color: #0F0;
}
@media (max-width: 380px) {
  .pull-right{
    float: left !important;
    padding-left:5px;
  }
}
</style>
<template>
  <div
    class="login-modal modal fade"
    id="loginModal"
    ref="login-modal"
    :style="$modalBackgroundStyle"
  >
    <a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
    <div class="row-col">
      <div class="p-a-lg h-v v-m">
        <div class="row">
          <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
            <div class="row">
              <div class="row item-list item-list-sm item-list-by m-b">
                <div class="col-xs-6">
                  
                  <div class="row">
                    
                    <div class="col-xs-12 col-sm-12 col-md-12" key="3" v-if="this.show.login" >
                      <h4 class="modal-title" :style="$highlightColor">Sign In To Continue</h4>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12" key="4" v-else>
                      <h4   class="modal-title" :style="$highlightColor">Sign Up To Continue</h4>
                    </div>
                    
                  </div>
                  
                  <div class="row">
                    <div class="col-xs-12 text-center tabs-menu">
                      <span
                        class="login-tab"
                        :class="{ 'selected-tab': show.login }"
                        :style="activeTabStyle('login')"
                        @click="showLogin"
                        >Login</span>
                      <span
                        class="register-tab"
                        :class="{ 'selected-tab': show.register }"
                        :style="activeTabStyle('register')"
                        @click="showRegister"
                        >Sign Up</span>
                    </div>
                  </div>
                  <div class="row position-relative" style="position:relative;">
                  <transition 
												name="view"
												:enter-class="show.login ? 'view-enter':'view-enter-reverse'"
												:leave-to-class="show.login ? 'view-leave-to':'view-leave-to-reverse'"
									>
                  <!-- the login tab -->
                  
                  <div class="col-xs-12 col-sm-12 col-md-12" key="1" v-if="this.show.login">
                    <transition name="fade">
                    <div
                      :style="buttonStyle.secondary"
                      v-if="loginError.has('other')"
                      class="alert alert-danger"
                      key="7"
                    >
                      <span v-for="error in loginError.get('other')">
                        {{error}}
                      </span>
                    </div>
                    </transition>
                    <div
                      class="form-group has-feedback"
                      :class="{ 'has-error': loginError.has('username') }"
                    >
                      
                      <base-control
                        key="username"
                        :constraints="configNameConstraints.username"
                        id="username"
                        label="Username or Email"
                        info-msg=""
                        error-msg="the username is required"
                        size="medium"
                        type="text"
                        v-model="username"
                      >
                      </base-control>
                      
                      <font-awesome-icon
                        icon="user"
                        class="form-control-feedback text-muted"
                      ></font-awesome-icon>
                      <span
                        class="text-danger"
                        v-if="loginError.has('username')"
                      >
                        <span v-for="error in loginError.get('username')">
                          {{ error }}
                        </span>
                      </span>
                    </div>
                    <div
                      class="form-group has-feedback"
                      :class="{ 'has-error': loginError.has('password') }"
                    >
                      
                      <base-control
                        key="password"
                        :constraints="configNameConstraints.password"
                        id="password"
                        error-msg="the Password is required "
                        label="Password"
                        info-msg=""
                        size="medium"
                        type="password"
                        v-model="password"
                      >
                      </base-control>
                     
                      <font-awesome-icon
                        icon="lock"
                        class="form-control-feedback text-muted"
                      ></font-awesome-icon>
                      <span
                        class="text-danger"
                        v-if="loginError.has('password')"
                      >
                        <span v-for="error in loginError.get('password')">{{
                          error
                        }}</span>
                      </span>
                    </div>
                    <div class="clearfix">
                      <div class="checkbox needsclick">
                        <div class="row">
                          <div :class="['col-sm-6','offset-3', dimensions.width<380? 'col-xs-12':'col-xs-6']">
                            <input type="checkbox" id="register-remember" name="register-remember" value="1" v-model="register.remember">
                            <label :style="cssVars" for="register-remember">Remember Me</label>
                          </div>
                          <div :class="['col-sm-6','offset-3', dimensions.width<380? 'col-xs-12':'col-xs-6']">
                            <div class="pull-right">
                              <a
                                :href="passwordUrl"
                                target="_blank"
                                class="forgot-password-link">Forgot password?</a>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    
                    <button
                      :style="buttonStyle.main"
                      class="login-button btn btn-block btn-login"
                      @click="validateAndLogin"
                      :disabled="this.loading.login || this.loading.register"
                    >
                      <font-awesome-icon
                        v-if="loading.login"
                        :icon="['far', 'spinner-third']"
                        spin
                      ></font-awesome-icon>
                      Login
                    </button>

                    <p class="text-center">
                      You don't have an account?
                    </p>
                    <div class="col-lg-6 offset-lg-3">
                      <button
                        :style="buttonStyle.secondary"
                        class="btn btn-block btn-secondary btn-login-secondary"
                        @click="showRegister"
                      >
                        Sign Up
                      </button>
                    </div>

                  </div>
                  <!-- the registration tab -->
                  <div class="col-xs-12 col-sm-12 col-md-12" key="2" style="position:absolute;" v-if="!this.show.login">
                    <div v-if="registerError.has('other')" class="alert alert-danger">
                      <span v-for="error in registerError.get('other')">
                        {{error}}
                      </span>
                    </div>
                    <div
                      class="form-group has-feedback"
                      :class="{ 'has-error': registerError.has('name') }"
                    >
                      
                      <base-control
                        key="register-name"
                        :constraints="configNameConstraints.name"
                        id="register-name"
                        label="Name"
                        info-msg=""
                        size="medium"
                        type="text"
                        v-model="registerObject.name"
                      >
                      </base-control>
                      <!-- <input type="text" class="form-control" v-model="registerObject.name" placeholder="Name" > -->
                      <font-awesome-icon
                        icon="user"
                        class="form-control-feedback text-muted"
                      ></font-awesome-icon>
                      <div v-if="registerError.has('name')" class="text-danger">
                        <span v-for="error in registerError.get('name')">{{
                          error
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="form-group has-feedback"
                      :class="{ 'has-error': registerError.has('username') }"
                    >
                      
                      <base-control
                        key="register-username"
                        :constraints="configNameConstraints.username"
                        id="register-username"
                        label="Username"
                        info-msg=""
                        size="medium"
                        type="text"
                        v-model="registerObject.username"
                      >
                      </base-control>
                      <!-- <input type="text" class="form-control" v-model="registerObject.username" placeholder="Username" > -->
                      <font-awesome-icon
                        icon="user"
                        class="form-control-feedback text-muted"
                      ></font-awesome-icon>

                      <div
                        v-if="registerError.has('username')"
                        class="text-danger"
                      >
                        <span v-for="error in registerError.get('username')">{{error}}</span>
                      </div>
                    </div>

                    <div
                      class="form-group has-feedback"
                      :class="{ 'has-error': registerError.has('email') }"
                    >
                      <base-control
                        key="register-email"
                        :constraints="configNameConstraints.email"
                        id="register-email"
                        label="Email Address"
                        info-msg=""
                        size="medium"
                        type="text"
                        v-model="registerObject.email"
                      >
                      </base-control>
                      
                      <font-awesome-icon
                        icon="at"
                        class="form-control-feedback text-muted"
                      ></font-awesome-icon>

                      <div
                        v-if="registerError.has('email')"
                        class="text-danger"
                      >
                        <span v-for="error in registerError.get('email')">{{
                          error
                        }}</span>
                      </div>
                    </div>

                    <div
                      class="form-group has-feedback"
                      :class="{ 'has-error': registerError.has('password') }"
                    >
                      
                      <base-control
                        key="register-password"
                        :constraints="configNameConstraints.password"
                        id="register-password"
                        label="Password"
                        size="medium"
                        type="password"
                        v-model="registerObject.password"
                      >
                      </base-control>
                      
                      <font-awesome-icon
                        icon="lock"
                        class="form-control-feedback text-muted"
                      ></font-awesome-icon>
                      <div
                        v-if="registerError.has('email')"
                        class="text-danger"
                      >
                        <span v-for="error in registerError.get('password')">{{
                          error
                        }}</span>
                      </div>
                      
                    </div>

                    <div class="form-group has-feedback" :class="{'has-error': registerError.has('password_confirmation')}">
                      
                      <base-control
                        key="password-confirmation"
                        :constraints="configNameConstraints.password_confirmation"
                        id="password-confirmation"
                        label="Confirm Password"
                        info-msg=""
                        size="medium"
                        type="password"
                        v-model="registerObject.password_confirmation"
                      >
                      </base-control>
                      
                      <font-awesome-icon
                        icon="lock"
                        class="form-control-feedback text-muted"
                      ></font-awesome-icon>

                      <div
                        v-if="registerError.has('password_confirmation')"
                        class="text-danger"
                      >
                        <span
                          v-for="error in registerError.get(
                            'password_confirmation'
                          )"
                          >{{ error }}</span>
                      </div>
                    </div>

                    <p class="terms-link text-center">
                      By signing up you automatically agree to our
                      <a
                        href="https://airbit.com/terms"
                        target="_top"
                        class="text-center url-link"
                        :style="$highlightColor"
                        >Terms &amp; Conditions</a>
                      and
                      <a
                        href="https://airbit.com/privacy"
                        target="_top"
                        class="text-center url-link"
                        :style="$highlightColor"
                        >Privacy agreement.</a
                      >
                    </p>

                    <div class="form-group">
                      <button
                        type="submit"
                        class="btn btn-block btn-primary btn-login"
                        :style="buttonStyle.main"
                        @click="validateAndRegister"
                        :disabled="this.loading.login || this.loading.register"
                      >
                        <font-awesome-icon
                          v-if="loading.register"
                          :icon="['far', 'spinner-third']"
                          spin
                        ></font-awesome-icon>
                        Sign Up
                      </button>
                    </div>
                    <p class="button-label">Already have an account?</p>
                    <div class="col-lg-6 offset-lg-3">
                      <button
                        style="margin-bottom:30px;"
                        class="btn btn-block btn-secondary btn-login-secondary "
                        :style='buttonStyle.secondary'
                        @click="showLogin"
                      >
                        Login
                      </button>
                      
                    </div>
                  </div>
                  <!-- end of registration tab -->
                  </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
	.view-enter-active {
		transition: opacity 0.2s ease-in-out, transform 0.2s ease;
	}
	.view-leave-active {
		transition: opacity 0.2s ease-in-out, transform 0.2s ease;
	}
	.view-enter-active {
		transition-delay: 0.2s;
	}
	/* The reverse is for the data we are loading */
	.view-enter {
		opacity: 0;
		transform: translateX(200px);
	}
	.view-enter-reverse{
		opacity: 0;
		transform: translateX(-200px);	
	}
	/* ------------------------------------------ */
	.view-enter-to {
		opacity: 1;
		transform: translateX(0px);
	}
	.view-leave {
		opacity: 1;
		transform: translateX(0px);
	}
	/* The reverse is for the data we are loading */
	.view-leave-to {
		opacity: 0;
		transform: translateX(-200px);
	}
	.view-leave-to-reverse {
		opacity: 0;
		transform: translateX(200px);
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
<script>
import Login from "../../mixins/login.vue";
import Configure from "./../../mixins/configure";

export default {
  mounted() {
    let vm = this;
    this.$nextTick(function() {
      $(this.$refs["login-modal"]).on("hidden.bs.modal", function() {
        vm.show.login = true;
        vm.show.register = false;
      });

      this.$store.commit("loginModal", { modal: $(this.$refs["login-modal"]) });
    });
    window.addEventListener('resize', this.onResize);
  },
  data() {
    return {
      configNameConstraints: {
        name: {
          presence: {
            allowEmpty: true,
            message: "Please enter your name."
          }
        },
        username: {
          presence: {
            allowEmpty: true,
            message: "Please enter a username."
          }
        },
        email: {
          presence: {
            allowEmpty: true,
            message: "Please enter an email."
          }
        },
        password: {
          presence: {
            allowEmpty: true,
            message: "Please enter a password."
          }
        },
        password_confirmation: {
          presence: {
            allowEmpty: true,
            message: "Please confirm your password."
          }
        }
      },
      username: "",
      password: "",
      loading: {
        login: false,
        register: false
      },
      show: {
        login: true,
        register: false
      },
      registerObject: {
        name: "",
        username: "",
        email: "",
        password: "",
        password_confirmation: "",
        remember: false
      },
      dimensions:{
        width:null,
        height:null
      },
      passwordUrl: ab.forgotPasswordUrl
    };
  },
  computed: {
    InfoCSSClasses(){
      return ['col-sm-6','offset-3', window.innerWidth<428? 'col-xs-12':'col-xs-6 offset-xs-3']
    },
    cssVars(){
      let mainStyle = this.$store.state.currentConfig.stylesConfig.main; 
      return {
        '--main-background-color': mainStyle.button_background.value,
        '--main-color': mainStyle.button_text.value,
        '--secondary-border-color': mainStyle.input_border.value,
        '--main-text': mainStyle.primary_text.value
      }
    },
    buttonStyle(){      
      let mainStyle = this.$store.state.currentConfig.stylesConfig.main;
      // button_text,button_background
      let mainStyles = {
        'color': mainStyle.button_text.value,
        'background-color': mainStyle.button_background.value,
        'border':'none'
      };
      // input_border, input_text, input_background
      let secondaryStyles = {
        'border': '1px solid '+mainStyle.input_border.value,
        'color': mainStyle.button_background.value,
        'background-color': mainStyle.input_background.value
      }
      return {main: mainStyles, secondary: secondaryStyles};
    },
    csrf() {
      return this.$store.state.csrfToken;
    },
    loginError() {
      if (this.$store.state.errors.login.any()) {
        this.loading.login = false;
      }
      return this.$store.state.errors.login;
    },
    registerError() {
      if (this.$store.state.errors.register.any()) {
        this.loading.register = false;
      }
      return this.$store.state.errors.register;
    }
  },
  mixins: [Login, Configure],
  methods: {
    showRegister() {
      this.show.register = true;
      this.show.login = false;
    },
    showLogin() {
      this.show.register = false;
      this.show.login = true;
    },
    validateAndLogin() {
      if (this.validateLogin()) {
        this.loading.login = true;
        this.login();
      }
    },
    validateLogin() {
      this.loginError.clear();

      if (this.username.length == 0)
        this.loginError.add("username", "Please enter your username or email.");
      if (this.password.length == 0)
        this.loginError.add("password", "Please enter your password.");

      return this.loginError.any() ? false : true;
    },
    validateAndRegister() {
      if (this.validateRegister()) {
        this.loading.register = true;
        this.register(this.registerObject);
      }
    },
    validateRegister() {
      this.registerError.clear();

      if (this.registerObject.name == "") {
        this.registerError.add("name", "Please enter your name.");
      }

      if (this.registerObject.username == "") {
        this.registerError.add("username", "Please enter a username or email.");
      }

      if (this.registerObject.email == "") {
        this.registerError.add("email", "Please enter an email.");
      }

      var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!regex.test(this.registerObject.email)) {
        var obj = this.registerError;
        
        if (this.registerObject.email!=="" && this.registerObject.email !== null){
          this.registerError.clearField("email");
          this.registerError.add(
            "email",
            "Your email must be a valid email address."
          );
        }
        
      }
    
      if ( this.registerObject.password == "" || this.registerObject.password.length < 6) {
        if(this.registerObject.password ==""){  
          this.registerError.add(
            "password",
            "Please enter a password."
          );
        }
        else {
          this.registerError.add(
            "password",
            "Your password must be a minimum of 6 characters."
          );
        }
      }

      if (
        this.registerObject.password !==
        this.registerObject.password_confirmation
      ) {
        this.registerError.add(
          "password_confirmation",
          "Your password confirmation must match your password."
        );
      }

      return this.registerError.any() ? false : true;
    },
    activeTabStyle(tab) {
      if (this.show[tab]) {
        return this.$highlightColor;
      } else {
        return {};
      }
    },
    onResize(){
      this.dimensions.width = window.innerWidth;
      this.dimensions.height = window.innerHeight;
    }
  },
  created(){
    this.dimensions.width = window.innerWidth;
    this.dimensions.height = window.innerHeight;
  }
  
};
</script>
